// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventsPage_wrapper_mVjqA"};